import { Component } from '@angular/core';
import { VoltaCommon } from '@core/common/volta-common';

@Component({
    selector: 'app-trademark',
    imports: [],
    templateUrl: './trademark.component.html',
    styleUrl: './trademark.component.scss'
})
export class TrademarkComponent {
    VoltaCommon = VoltaCommon;
}
